import { render, staticRenderFns } from "./comprobante.vue?vue&type=template&id=9caf8f90&scoped=true"
import script from "./comprobante.vue?vue&type=script&lang=js"
export * from "./comprobante.vue?vue&type=script&lang=js"
import style0 from "./comprobante.vue?vue&type=style&index=0&id=9caf8f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caf8f90",
  null
  
)

export default component.exports